import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { Subscription } from 'rxjs';
import {
  NotificationServicezz,
  NewNotificationResponse,
} from '../../core/services/notification.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Notification } from '../../core/notifications/notification.model';
import { selectNotifications } from '../../core/notifications/notification.selector';
import { NotificationService } from '../../features/notifications/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { MatDialog } from '@angular/material/dialog';
import { filter, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, LayoutComponent],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  myNotifications$: Observable<Notification[]>;
  notifications: NewNotificationResponse['newNotification'][] = [];
  private subscription: Subscription | null = null;
  readonly dialog = inject(MatDialog);

  constructor(
    private notificationService: NotificationService,
    private store: Store,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.myNotifications$ = this.store.select(selectNotifications);
    // Debug: Log notifications whenever they change
    this.myNotifications$.subscribe((notifications) => {
      console.log('Notificationsss:', notifications);
    });
  }

  isDropdownOpen = false;

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

//   handleStatus(id: any, status: any) {
//     const dialogRef = this.dialog.open(ConfirmDialog,{
//       data: {
//         title: `Confirm ${status}?`,
//         message: `Are you sure you want to ${status} this notification?`,
//         confirmText: `${status}`
//       }
//     });
//     dialogRef.afterClosed().subscribe((result) => {
//       if (result === true) {
//     if (status === 'Approve') {
//     this.notificationService.approveNotification(Number(id)).subscribe({
//         next: (data) => {
//           if (data) {
//             this.toastr.success(
//               'Notification approved successfully',
//               'Success'
//             );
//             this.notificationService.loadNotifications();
//             this.myNotifications$ = this.store.select(selectNotifications);
//             // console.log('this.myNotifications$',this.myNotifications$);
            
//             // this.notificationService.loadNotifications();
//             // this.notificationService.startListening();
//           }
//         },
//         error: (error) => {
//           this.toastr.error(error, 'Error');
//         },
//       });
//     } else if (status === 'Reject') {
//       this.notificationService.rejectNotification(Number(id)).subscribe({
//         next: (data) => {
//           if (data) {
//             this.toastr.success(
//               'Notification rejected successfully',
//               'Success'
//             );
//             this.notificationService.loadNotifications().subscribe(() => {
//               this.notificationService.startListening();
//               // this.myNotifications$ = this.store.select(selectNotifications);

//             });
//           }
//         },
//         error: (error) => {
//           this.toastr.error(error, 'Error');
//         },
//       });
//     }
//   }
//   })
// }
handleStatus(id: any, status: any) {
  const dialogRef = this.dialog.open(ConfirmDialog, {
    data: {
      title: `Confirm ${status}?`,
      message: `Are you sure you want to ${status} this notification?`,
      confirmText: `${status}`
    }
  });

  dialogRef.afterClosed().pipe(
    filter(result => result === true),
    switchMap(() => {
      const serviceCall = status === 'Approve' 
        ? this.notificationService.approveNotification(Number(id))
        : this.notificationService.rejectNotification(Number(id));
      
      return serviceCall.pipe(
        tap(() => {
          this.toastr.success(
            `Notification ${status.toLowerCase()}ed successfully`,
            'Success'
          );
        }),
        switchMap(() => this.notificationService.loadNotifications())
      );
    })
  ).subscribe({
    error: (error) => this.toastr.error(error, 'Error')
  });
}
}
